var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isRendering)?_c('DotLoadingPage'):_vm._e(),_c('TopicFormationDashboardLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }